// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"f4cacf2977ded5308919","655":"d1ed75362395c152b42a"}[chunkId] + ".js";
};